// @flow

// Vendors
import React from 'react';
import classnames from 'classnames';

// Types
type Props = {
  users: Array<Object>,
  type: 'admin' | 'active' | 'pending' | 'inactive',
  handleUpdateStatusClick: Function,
  className?: string
};

const UserList = ({
  users,
  type,
  handleUpdateStatusClick,
  className
}: Props) => {
  const { currentUser } = window;
  const organizationRoles = {
    admin: 'Admin',
    member: 'Member',
    pending: 'Pending',
    inactive: 'Inactive'
  };

  return (
    <ul className={classnames('user-list', className)}>
      {users.map(
        ({ id, initials, first_name, last_name, organization_role }) => {
          return (
            <li key={id} className="user-list__item">
              <div className="user-list__info">
                <span className="user-avatar">{initials}</span>
                <div>
                  <strong>
                    {first_name} {last_name}
                  </strong>
                  <small>{organizationRoles[organization_role]}</small>
                </div>
              </div>

              <div className="user-list__actions">
                {(type === 'admin' || type === 'active') && (
                  <>
                    <a
                      href={`/resource-center/users/edit/?user_id=${id}`}
                      className="btn btn--primary"
                    >
                      Edit
                    </a>
                    {id != currentUser.id && (
                      <button
                        href="#"
                        className="btn btn--gray"
                        onClick={() => handleUpdateStatusClick(id, 'inactive')}
                      >
                        Deactivate
                      </button>
                    )}
                  </>
                )}

                {type === 'pending' && (
                  <>
                    <button
                      className="btn btn--primary"
                      onClick={() => handleUpdateStatusClick(id, 'member')}
                    >
                      Approve
                    </button>
                    <button
                      className="btn btn--gray"
                      onClick={() => handleUpdateStatusClick(id, 'rejected')}
                    >
                      Reject
                    </button>
                  </>
                )}

                {type === 'inactive' && (
                  <button
                    className="btn btn--primary"
                    onClick={() => handleUpdateStatusClick(id, 'member')}
                  >
                    Restore
                  </button>
                )}
              </div>
            </li>
          );
        }
      )}
    </ul>
  );
};

export default UserList;
